import React from "react";
const islaminHuccetiLarge = require('../../../assets/books/kapaklar/islam-hucceti_600.jpg');
const islaminHuccetiMini = require('../../../assets/books/kapaklar/islam-hucceti-300.jpg');
export const IslaminHuccetiDescription = (props: any) => {
    return (
        <div className="summary-description">
            <div className="book-image">
                <img
                    src={islaminHuccetiLarge}
                    alt="Aşka Meşke Semaya Yolculuk"
                    srcSet={`${islaminHuccetiMini} 300w, ${islaminHuccetiLarge} 600w`}
                    sizes={"(max-width: 600px) 300px,  600px"}
                />
            </div>
            <p>
                İnsan, kâinatta seçkin bir yeri olan ve yüksek
                bir gaye için yaratılan şerefli bir varlıktır. İnsan, sonsuz hayata burada hazırlanacaktır.
            </p>
            <p>
                Yüce Allah, bizi ebedî saadet yurduna çağırarak hazırlık yapmamızı istemiş ve sonsuz mutluluğa
                kavuşmanın yollarını göstermiştir.
                Bizim görevimiz: yaratılışımızın gayesine uygun olarak, önce doğru bir inanca sahip olmak,
                sonra da inancımızın gereği olan ibadet vazifelerini yerine getirmek, kalbimizi iyi düşüncelerle
                süslemek ve ahlâk ölçülerine uygun hareket ederek kulluk imtihanında başarılı olmaktır.
                Üzerimize düşen dinî görevleri yerine getirebilmemiz şüphesiz yeterli bilgiye sahip olmakla mümkündür.
            </p>
            <p>
                Elinizdeki bu kitap, her yaşta müslümanın ve özellikle her yaştaki Müslüman kardeşlerimizin
                ihtiyacı olan dinî temel bilgileri alabileceği ve kolaylıkla anlayabileceği sade bir dille hazırlanmıştır.
                Bu kitabın bütün okuyucularımıza yararlı olmasını Allah'tan niyaz ederiz.
            </p>
        </div>
    )
}
export const IslaminHuccetiSummaryDescription = (props: any) => {
    return (
        <p>
            İnsan, kâinatta seçkin bir yeri olan ve yüksek
            bir gaye için yaratılan şerefli bir varlıktır. İnsan, sonsuz hayata burada hazırlanacaktır.
            Yüce Allah, bizi ebedî saadet yurduna çağırarak hazırlık yapmamızı istemiş ve sonsuz mutluluğa
            kavuşmanın yollarını göstermiştir.
            Bizim görevimiz: yaratılışımızın gayesine uygun olarak, önce doğru bir inanca sahip olmak,
            sonra da inancımızın gereği olan ibadet vazifelerini yerine getirmek, kalbimizi iyi düşüncelerle
            süslemek ve ahlâk ölçülerine uygun hareket ederek kulluk imtihanında başarılı olmaktır.
            Üzerimize düşen dinî görevleri yerine getirebilmemiz şüphesiz yeterli bilgiye sahip olmakla mümkündür.
        </p>
    )
}